import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

function Loading(props) {
  return props.loading ? <LinearProgress/> : null;
}

export default Loading;